import React from "react";

/**
 * Balbis wordmark SVG logo.
 * Uses fill="currentColor" so it inherits the parent's text color.
 */
export default function BalbisLogo({ className = "", style = {} }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 476.59 165.8"
      fill="currentColor"
      className={className}
      style={style}
      aria-label="Balbis"
    >
      <path d="M28.2,71.4l18.4-19.2c4-2,9-3,14.8-3,22.2,0,39,18.4,39,48.2,0,42-30,67-69.4,67H0c3.6-11.4,5.4-23.6,5.4-36.2V43C5.4,25.2,3.8,15.8,0,6.4L33,0c-3,11.8-4.8,32-4.8,53.4v18ZM28.2,147.6c4.2,1,8.8,1.4,14,1.4,19.4,0,33.8-14.8,33.8-41.4s-14.6-36.4-29-36.4c-6.6,0-13,2.2-18.8,6.6v69.8Z"/>
      <path d="M184,133.4c0,13,1.6,20.8,6.2,31h-29v-12.8c-6.2,3.6-12.6,8-19,13.2-1,.2-2.4.2-4.4.2-21.4,0-33.6-11-33.6-28.4,0-12.2,6.6-21,26.4-30.4,6.2-3,16.4-7.4,30.6-13.4v-4.6c0-13.4-8.2-21.2-21.2-21.2-8.4,0-16.8,2.6-25,7.8l-.4-.4,8-22c7.4-2.4,15.2-3.6,23.6-3.6,24.8,0,37.8,12.4,37.8,35.6v49ZM132.4,113.6c-2.6,4.6-3.8,9.6-3.8,14.8,0,11.8,8.4,17.8,25,17.8,2.4,0,5-.2,7.6-.8v-31.8h-28.8Z"/>
      <path d="M208.6,43c0-17.8-1.6-27.2-5.4-36.6L236.2,0c-3,11.8-4.8,32-4.8,53.4v80c0,12.2,1.4,20.6,5.6,31h-33.8c4-10.4,5.4-19,5.4-31V43Z"/>
      <path d="M280.59,71.4l18.4-19.2c4-2,9-3,14.8-3,22.2,0,39,18.4,39,48.2,0,42-30,67-69.4,67h-31c3.6-11.4,5.4-23.6,5.4-36.2V43c0-17.8-1.6-27.2-5.4-36.6l33-6.4c-3,11.8-4.8,32-4.8,53.4v18ZM280.59,147.6c4.2,1,8.8,1.4,14,1.4,19.4,0,33.8-14.8,33.8-41.4s-14.6-36.4-29-36.4c-6.6,0-13,2.2-18.8,6.6v69.8Z"/>
      <path d="M392.39,133.4c0,12.2,1.4,20.6,5.6,31h-33.8c4-10.4,5.4-19,5.4-31v-51.8c0-12-1.4-20.6-5.4-31h33.8c-4.2,10.4-5.6,18.8-5.6,31v51.8ZM381.19,35.4c-9,0-16.2-7.2-16.2-16s7.2-16,16.2-16,15.8,7.2,15.8,16-7,16-15.8,16Z"/>
      <path d="M411.19,130h.6c9,15.2,15.6,20.4,26.2,20.4,9.8,0,15.2-5,15.2-14,0-4.2-1.2-7.6-3.8-10.6-2.4-3-7.2-7-14.6-11.6-16-10.4-21.4-19.6-21.4-33,0-18.6,15.2-32.4,37.4-32.4,7.8,0,15.2,1.2,22.2,3.4v21.6h-.6c-8.6-7.2-14.6-9.8-21.8-9.8-9,0-14.2,4.6-14.2,12.4,0,8.2,4.6,13.6,17.6,21.6,16.2,9.8,22.6,19.2,22.6,33.4,0,21.8-15.8,34.4-37.6,34.4-10.6,0-18.2-1.2-29.2-4.2l1.4-31.6Z"/>
    </svg>
  );
}
